export default __webpack_public_path__ + "static/media/Screenshot_13.b1bb4bce.png";